import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListEmspUserDidCell } from './emsp-bo-rfid-badge-order-list-emsp-user-did.cell';
import { EmspBoRfidBadgeOrderListEmspUserDidHeader } from './emsp-bo-rfid-badge-order-list-emsp-user-did.header';

export const EmspBoRfidBadgeOrderListEmspUserDidColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['emspUser']['did']
> = {
  id: 'emspUserDid',
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListEmspUserDidHeader,
  cell: EmspBoRfidBadgeOrderListEmspUserDidCell,
};
